/* eslint-disable react/react-in-jsx-scope */
export default function CheckMark({iconStyle, iconColor})  {
    return (
    <svg style={iconStyle} xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
    <path d="M13.59 2.34779L6.20426 9.59702C5.65741 10.1338 4.7703 10.1338 4.22277 9.59702L0.410393 5.8544C-0.136798 5.31727 -0.136798 4.44647 0.410393 3.90933C0.957584 3.3722 1.8447 3.3722 2.39189 3.90899L5.2142 6.67942L11.6085 0.402721C12.1557 -0.13441 13.0428 -0.134071 13.59 0.402721C14.1368 0.939513 14.1368 1.81032 13.59 2.34779Z" fill={iconColor || "#13BCB4"}/>
    </svg>
    );
};